"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndustrialCenterAres = void 0;
var CardName_1 = require("../../CardName");
var SpaceBonus_1 = require("../../SpaceBonus");
var IndustrialCenter_1 = require("../base/IndustrialCenter");
var TileType_1 = require("../../TileType");
var CardRenderer_1 = require("../render/CardRenderer");
var IndustrialCenterAres = (function (_super) {
    __extends(IndustrialCenterAres, _super);
    function IndustrialCenterAres() {
        return _super.call(this, CardName_1.CardName.INDUSTRIAL_CENTER_ARES, { bonus: [SpaceBonus_1.SpaceBonus.STEEL] }, {
            cardNumber: 'A10',
            renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                b.action('Spend 7 M€ to increase your steel production 1 step.', function (eb) {
                    eb.megacredits(7).startAction.production(function (pb) { return pb.steel(1); });
                }).br;
                b.tile(TileType_1.TileType.INDUSTRIAL_CENTER, false, true).asterix();
            }),
            description: 'Place this tile adjacent to a city tile. This tile grants an ADJACENCY BONUS of 1 steel.',
        }) || this;
    }
    return IndustrialCenterAres;
}(IndustrialCenter_1.IndustrialCenter));
exports.IndustrialCenterAres = IndustrialCenterAres;
//# sourceMappingURL=IndustrialCenterAres.js.map